// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../../queries/fragments.generated';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChooseOptionsStepBodyV1QueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  filter: Types.GlobalOptionsFilter;
}>;


export type ChooseOptionsStepBodyV1Query = { __typename?: 'Query', readyPlanLike2:
    | { __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'PlanPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'DesignPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'ProductOffering', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
  , globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, code: string, lastUsedAt?: Types.Scalars['DateTime']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, type: { __typename?: 'GlobalOptionType', allowsLocations: boolean, id: string, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> }> };

export type ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables = Types.Exact<{
  input: Types.SaveReadyPlanOptionsInput;
}>;


export type ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation = { __typename?: 'Mutation', saveReadyPlanOptions: { __typename?: 'SaveReadyPlanOptionsResult', readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } };

export type ChooseOptionsStepBodyV1_ReadyPlanLike_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ChooseOptionsStepBodyV1_ReadyPlanLike_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ChooseOptionsStepBodyV1_ReadyPlanLike_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ChooseOptionsStepBodyV1_ReadyPlanLike_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ChooseOptionsStepBodyV1_ReadyPlanLikeFragment =
  | ChooseOptionsStepBodyV1_ReadyPlanLike_ReadyPlan_Fragment
  | ChooseOptionsStepBodyV1_ReadyPlanLike_PlanPackage_Fragment
  | ChooseOptionsStepBodyV1_ReadyPlanLike_DesignPackage_Fragment
  | ChooseOptionsStepBodyV1_ReadyPlanLike_ProductOffering_Fragment
;

export type ChooseOptionsStepBodyV1_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, active: boolean, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } };

export type ChooseOptionsStepBodyV1_GlobalOptionFragment = { __typename?: 'GlobalOption', id: string, name: string, code: string, lastUsedAt?: Types.Scalars['DateTime']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, type: { __typename?: 'GlobalOptionType', allowsLocations: boolean, id: string, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> };

export const ChooseOptionsStepBodyV1_ReadyPlanOptionFragmentDoc = gql`
    fragment ChooseOptionsStepBodyV1_ReadyPlanOption on ReadyPlanOption {
  id
  active
  location {
    id
  }
  globalOption {
    id
  }
  type {
    id
  }
}
    `;
export const ChooseOptionsStepBodyV1_ReadyPlanLikeFragmentDoc = gql`
    fragment ChooseOptionsStepBodyV1_ReadyPlanLike on ReadyPlanLike {
  id
  name
  options {
    ...ChooseOptionsStepBodyV1_ReadyPlanOption
  }
  canEdit {
    ...PotentialOperationDetails
  }
}
    ${ChooseOptionsStepBodyV1_ReadyPlanOptionFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const ChooseOptionsStepBodyV1_GlobalOptionFragmentDoc = gql`
    fragment ChooseOptionsStepBodyV1_GlobalOption on GlobalOption {
  id
  name
  code
  statusDetail {
    code
    name
  }
  type {
    ...Named
    allowsLocations
  }
  lastUsedAt
  updatedAt
  createdAt
  tags {
    id
    name
  }
}
    ${NamedFragmentDoc}`;
export const ChooseOptionsStepBodyV1Document = gql`
    query ChooseOptionsStepBodyV1($readyPlanId: ID!, $filter: GlobalOptionsFilter!) {
  readyPlanLike2(id: $readyPlanId) {
    ...ChooseOptionsStepBodyV1_ReadyPlanLike
  }
  globalOptions(filter: $filter) {
    ...ChooseOptionsStepBodyV1_GlobalOption
  }
}
    ${ChooseOptionsStepBodyV1_ReadyPlanLikeFragmentDoc}
${ChooseOptionsStepBodyV1_GlobalOptionFragmentDoc}`;

/**
 * __useChooseOptionsStepBodyV1Query__
 *
 * To run a query within a React component, call `useChooseOptionsStepBodyV1Query` and pass it any options that fit your needs.
 * When your component renders, `useChooseOptionsStepBodyV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseOptionsStepBodyV1Query({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChooseOptionsStepBodyV1Query(baseOptions: ApolloReactHooks.QueryHookOptions<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables> & ({ variables: ChooseOptionsStepBodyV1QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>(ChooseOptionsStepBodyV1Document, options);
      }
export function useChooseOptionsStepBodyV1LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>(ChooseOptionsStepBodyV1Document, options);
        }
// @ts-ignore
export function useChooseOptionsStepBodyV1SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>;
export function useChooseOptionsStepBodyV1SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseOptionsStepBodyV1Query | undefined, ChooseOptionsStepBodyV1QueryVariables>;
export function useChooseOptionsStepBodyV1SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>(ChooseOptionsStepBodyV1Document, options);
        }
export type ChooseOptionsStepBodyV1QueryHookResult = ReturnType<typeof useChooseOptionsStepBodyV1Query>;
export type ChooseOptionsStepBodyV1LazyQueryHookResult = ReturnType<typeof useChooseOptionsStepBodyV1LazyQuery>;
export type ChooseOptionsStepBodyV1SuspenseQueryHookResult = ReturnType<typeof useChooseOptionsStepBodyV1SuspenseQuery>;
export type ChooseOptionsStepBodyV1QueryResult = ApolloReactCommon.QueryResult<ChooseOptionsStepBodyV1Query, ChooseOptionsStepBodyV1QueryVariables>;
export const ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDocument = gql`
    mutation ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptions($input: SaveReadyPlanOptionsInput!) {
  saveReadyPlanOptions(input: $input) {
    readyPlanOptions {
      id
      active
    }
  }
}
    `;

/**
 * __useChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation__
 *
 * To run a mutation, you first call `useChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseOptionsStepBodyV1SaveReadyPlanChosenOptionsMutation, { data, loading, error }] = useChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation, ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation, ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables>(ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDocument, options);
      }
export type ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationHookResult = ReturnType<typeof useChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation>;
export type ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationResult = ApolloReactCommon.MutationResult<ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation>;